import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ModalService } from 'src/app/common/modal/modal.service';
import { APP_Constants } from 'src/app/app.constant';
import FileSaver from 'file-saver';
import { Modal } from 'src/app/common/modal/modal';

@Component({
    selector: 'app-help-center',
    templateUrl: './help-center.component.html',
    styleUrls: ['./help-center.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HelpCenterComponent implements OnInit {
  userRole: string;
  customerCode: string;

  constructor(private appService: AppService,private modalService: ModalService) { }

  ngOnInit(): void {
  }
  downloadFile() {
    this.userRole = localStorage.getItem('userRole');
    this.customerCode = localStorage.getItem("customerCode")
    let API = APP_Constants.TRAINING_DOC_DOWNLOAD+"?customerCode="+this.customerCode+"&userId="+localStorage.getItem('userName')+"&documentType=HelpDocument&role="+this.userRole;
    this.appService.makeHttpGetRequest(API).subscribe((res: any) => {
      let fileName = res?.FileName;
      let base64File = 'data:' + res['Content-Type'] + ';base64,' + res.Data;
      FileSaver.saveAs(base64File, fileName);
    }, async (err) => {
      let modal = new Modal({
        action: false, name: 'download', title: 'Download File', actionButtonText: '',description: 'There was an error in downloading the file. Please try again later.'
      });
      this.modalService.createModalBox(modal, err.status);
    })
  }
}
